'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidDesktop = function IoAndroidDesktop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 2.5c1.8 0 3.4 1.6 3.4 3.4v22c0 1.8-1.6 3.4-3.4 3.4h-10.7l3.2 3.7v2.5h-13.2v-2.5l3.2-3.7h-10.7c-1.8 0-3.4-1.6-3.4-3.4v-22c0-1.8 1.6-3.4 3.4-3.4h28.2z m0 22.5v-19.1h-28.2v19.1h28.2z' })
        )
    );
};

exports.default = IoAndroidDesktop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-desktop.js
// module id = 1880
// module chunks = 0